import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";

import Pick from "./pick";

class EditorPicks extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      description: "",
      id: "",
      title: "",
      pageUrl: "",
      visible: 3
    };

    this.renderEditorPicks = this.renderEditorPicks.bind(this);
  }

  componentDidMount() {
    this.renderEditorPicks();
  }

  renderEditorPicks() {
    axios
      .get(this.props.api.editorpicks)
      .then(results => {
        const data = results.data.FeaturedPicks;
        this.setState({
          data: data,
          title: results.data.Title
        });
      })
      .catch(err => {
        throw err;
      });
  }

  render() {
    return (
      <div className="editorPicks">
        <h2 className="editorPicksTitle">{this.state.title}</h2>
        <div className="editorPicksItem">
          {this.state.data.map(pick => (
            <Pick key={pick.ItemID} description={pick.Title} link={pick.PageUrl} />
          ))}
        </div>
      </div>
    );
  }
}

EditorPicks.propTypes = {
  api: PropTypes.object
};

export default EditorPicks;
